import { GamoraFoundationError } from '../foundation/error/error.js';

/**
 * Validation error
 * @public
 */
export class GamoraErrorValidation extends GamoraFoundationError {
  constructor(message?: string) {
    super(message);
  }
}
